module.exports = "<div class=\"modal-header\" style=\"padding-right: 60px\">\n    <h4 class=\"modal-title\">{{title}}</h4>\n    <div class=\"icon-button black corner\" ng-click=\"cancel()\">\n        <i class=\"material-icons\">clear</i>\n    </div>\n</div>\n\n<div class=\"modal-body\">\n\n    {{content}}\n\n</div>\n<div class=\"modal-footer\">\n    <div class=\"right\">\n        <button ng-click=\"confirm()\" ng-show=\"confirmText\">{{confirmText}}</button>\n        <button class=\"quiet inverted\" ng-click=\"cancel()\" ng-show=\"cancelText\">{{cancelText}}</button>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/dialog/dialog.html
// module id = 19
// module chunks = 0